import React from 'react';

interface IconProps extends React.SVGProps<SVGSVGElement> {
  fillColor?: string; // Accepts color values or 'currentColor'
}

const InstrumentIcon: React.FC<IconProps> = ({ fillColor, ...props }) => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g id="smallIcon">
        <rect id="Rectangle 7297" x="2" y="3" width="4" height="11" stroke="white" />
        <rect id="Rectangle 7298" x="6" y="3" width="4" height="11" stroke="white" />
        <rect id="Rectangle 7299" x="10" y="3" width="4" height="11" stroke="white" />
        <rect id="Rectangle 7300" x="5" y="3" width="2" height="7" fill={fillColor || 'white'} />
        <rect id="Rectangle 7301" x="9" y="3" width="2" height="7" fill={fillColor || 'white'} />
      </g>
    </svg>
  );
};

export { InstrumentIcon };
